<template lang="pug">
	.packages-selection
		.flex-col.space-large
			CartoMap(ref="map",
				:layers="layers",
				:boundingBox="boundingBox",
				:geoJsonDrawings="drawings",
				:geoJsonStyle="{ fillColor: '#f27649', fillOpacity: 0.1, color: '#f27649', colorOpacity: 0.3, weight: 1 }",
				:showFilters="false"
			)
				.region-selection(slot="map")
					.flex-col.space-large
						DxSelectBox(:data-source="countries", :searchEnabled="true", :value.sync="data.packageCountry", display-expr="name", value-expr="name", :placeholder="$tCaption('Country')")
						DxSelectBox(:disabled="!states.length", :data-source="states", :searchEnabled="true", :value.sync="data.packageState", display-expr="name", value-expr="name", :placeholder="$tCaption('State')")
						DxSelectBox(:disabled="!cities.length", :data-source="cities", :searchEnabled="true", :value.sync="data.packageCity", display-expr="name", value-expr="name", :placeholder="$tCaption('City')")
		.stations-selection.flex-col.space.center.align-center
			.font-big.upper.grey {{$tCaption('Stations selection')}}
			.flex-row.wrap.center.align-center
				.station.clickable.flex-col.space.center.align-center(v-for="station in stations.slice(stationsCurrentPage * stationsItemsPerPage, (stationsCurrentPage + 1) * stationsItemsPerPage)"
					:class="{ selected: data.radios.indexOf(station.station) > -1 }", @click="toggleSelectedIdInArray(station.station, data.radios)"
				)
					template(v-if="station.logo")
						.image(v-if="station.logo", :style="{ background: `url(${station.logo})` }")
					template(v-else)
						.icon
							i.fas.fa-broadcast-tower
						.right.flex-col.space
							.station-name {{station.station}}
							.band {{station.freq1}} {{station.band}}
			Pager(:count="stationsTotalPages", v-model="stationsCurrentPage")
</template>

<script>
	import _ from 'lodash';
	import Data from 'app-core/Data';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import CartoMap from '../carto/CartoMapComponent.vue';
	import Pager from 'app-core/Pager.vue';

	export default {
		translationCategory: 'proposal.PackagesSelection',
		name: 'packages-selection',
		components: {DxSelectBox, DxDateBox, CartoMap, Pager},
		mixins: [Data.mixin],
		props: ['data'],
		data() {
			return {
				countries: [],
				states: [],
				cities: [],
				radioLayer: {
					query: null,
					customStyle: `
						#layer[zoom>3] {
							polygon-fill: #f27649;
							polygon-opacity: 0.025;
						}
						#layer::outline[zoom>8] {
							line-width: 1;
							line-color: #f27649;
							line-opacity: 0.2;
						}
						#layer::labels[zoom>8] {
							text-name: [station];
							text-face-name: 'DejaVu Sans Book';
							text-size: 10;
							text-fill: #FFFFFF;
							text-label-position-tolerance: 0;
							text-halo-radius: 2;
							text-halo-fill: #f27649;
							text-dy: -10;
							text-allow-overlap: false;
							text-placement: point;
							text-placement-type: dummy;
						}
					`
				},
				stations: [],
				boundingBox: null,
				area: null,
				latLng: null,
				stationsCurrentPage: 0,
				stationsItemsPerPage: 20
			};
		},
		computed: {
			stationsTotalPages() {
				return Math.ceil(this.stations.length / this.stationsItemsPerPage);
			},
			layers() {
				return this.radioLayer.query ? [this.radioLayer] : [];
			},
			drawings() {
				return this.area ? [this.area] : [];
			}
		},
		watch: {
			'data.packageCountry'(v) {
				this.data.packageState = null;
				this.data.packageCity = null;
				this.loadStates();
			},
			'data.packageState'(v) {
				this.city = null;
				if (v) {
					this.loadCities();
					this.setView();
				}
			},
			'data.packageCity'(v) {
				if (v) {
					this.setView().then(() => this.setQuery());
				}
			}
		},
		mounted() {
			if (this.data.packageCountry && (this.data.packageState || this.data.packageCity))
				this.setView().then(() => {
					if (this.data.packageCity)
						this.setQuery();
				});
			Data.getCountries().then(r => {
				this.countries = r;
				if (!this.data.packageCountry)
					this.data.packageCountry = 'USA';
				else {
					this.loadStates();
					if (this.data.packageState)
						this.loadCities();
				}
			});
		},
		methods: {
			loadStates() {
				Data.getStates(this.data.packageCountry).then(r => {
					if (__DEBUG__)
						console.info('States loaded', { r, v: this.data.packageCountry });
					this.states = r;
				});
			},
			loadCities() {
				Data.getCities(this.data.packageCountry, this.data.packageState).then(r => {
					if (__DEBUG__)
						console.info('Cities loaded', { r });
					this.cities = r;
				});
			},
			setQuery() {
				this.radioLayer.query = `
					SELECT *, case band when 'FM' then freq::decimal/10 else freq end as freq1
					FROM us_radio
					where ST_intersects(
						the_geom,
						ST_SetSRID(ST_GeomFromGeoJSON('${JSON.stringify(this.area)}'), 4326)
					)`;
				this.loadRadios();
			},
			setView() {
				if (__DEBUG__)
					console.info('Set view');
				return Data.getLocationGeoJson({
					country: this.data.packageCountry,
					state: this.data.packageState,
					city: this.data.packageCity
				}).then(r => {
					if (__DEBUG__)
						console.info('Set view', r);
					if (r && r.length) {
						this.boundingBox = r[0].boundingbox;
						this.area = r[0].geojson;
						this.latLng = [r[0].lat, r[0].lon];
					}
				});
			},
			loadRadios() {
				if (__DEBUG__)
					console.info('Load radios');
				if (!this.radioLayer.query) return;
				Data.getCartoSql(this.radioLayer.query).then(r => {
					this.stations = _.sortBy(r, ['station']);
				});
			}
		}
	};
</script>
<style lang='scss'>
	.packages-selection {
		@import "main/themes/generated/variables.base.scss";

		.map-holder {
			height: 300px;
		}

		.stations-selection {
			margin-top: 20px;
		}

		.station {
			filter: grayscale(1);
			transition: 0.3s;
			border-bottom: 2px solid #00000014;
			height: 120px;
			margin: 10px 40px;
			opacity: 0.5;

			> .image {
				width: 120px;
				height: 80px;
				margin: 5px;
				background-size: contain !important;
				background-repeat: no-repeat !important;
				background-position: center !important;
			}

			> .icon {
				font-size: 26px;
				color: #f27649;
			}

			.band {
				color: #33333363;
				font-size: 16px;
			}

			.station-name {
				font-weight: 600;
			}


			&:hover, &.selected {
				filter: grayscale(0);
				transform: scale(1.1);
				border-bottom: 2px solid $base-accent;
				opacity: 1;

				.band {
					color: #f27649;
					font-size: 16px;
				}
			}
		}

		.region-selection {
			position: absolute;
			top: 20px;
			left: 60px;
			width: 300px;
			background: rgba(255, 255, 255, 0.8);
			z-index: 1000;
			padding: 16px;
			border-radius: 2px;
		}
	}
</style>
